<template>
  <div class="image-options-data-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown($event, '1')" title="数据源" name="1">
        <div>
          <div class="data-source-type">
            <cx-slider :value.sync="notLocal" :options="dataOptions" :height="32" />
          </div>
          <div v-if="isShowChooseData" class="dataSource-item mt12" @click="goToChooseData">
            <span>进入数据管理后台 </span>
          </div>
          <div v-show="pageType !== 'detailPage' && noCacheComponent && noCacheComponent !== '3' && !noCacheComponentLayout">
            <data-center-choose 
              :checkStatus="checkStatus"
              :myId="ids"
              :options="options"
              class="mt12"
              @onDataCenterChange="onDataCenterChange"
            />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item 
        v-if="noCacheComponent === '3' && directionTitle" 
        title="数据绑定"
        name="4">
        <currentFieldMappingSetting :myid="ids" :options="options"></currentFieldMappingSetting>
        <emptyDataShow class="mt12" :options="options"></emptyDataShow>
      </el-collapse-item>
      <el-collapse-item
        v-if="(showColsFieldMapping && (noCacheComponentLayout || hasGetDetailDataPlugin) && notLocal && !multiImageDetail) || (!noCacheComponentLayout && pageType === 'detailPage' && noCacheComponent) || (noCacheComponentLayout && notLocal && multiImageDetail)"
        @mousedown.native="collapseMouseDown($event, '4')"
        title="数据绑定"
        name="4"
      >
        <div v-if="showColsFieldMapping && (noCacheComponentLayout || hasGetDetailDataPlugin) && notLocal && !multiImageDetail" class="content">
          <colsFieldMappingSetting :ids="dataIds" :myId="ids" :options="options" v-if="showColsFieldMapping"></colsFieldMappingSetting>
        </div>
        <div v-else-if="noCacheComponentLayout && notLocal && multiImageDetail">
          <multiImageFieldMappingSetting :myid="ids" :options="options"></multiImageFieldMappingSetting>
          <emptyDataShow class="mt12" :options="options"></emptyDataShow>
        </div>
        <div v-else-if="pageType === 'detailPage'">
          <detailPageFieldMappingSetting :myid="ids" :options="options"></detailPageFieldMappingSetting>
          <emptyDataShow class="mt12" :options="options"></emptyDataShow>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="pageType === 'listPage' && !noCacheComponentLayout && noCacheComponent === '3' && !directionTitle"
        @mousedown.native="collapseMouseDown($event, '4')"
        title="数据绑定"
        name="4"
      >
        <listPageFieldMappingSetting :myid="ids" :options="options"></listPageFieldMappingSetting>
        <emptyDataShow class="mt12" :options="options"></emptyDataShow>
      </el-collapse-item>
      <el-collapse-item
        v-if="!notLocal"
        @mousedown.native="collapseMouseDown($event, '2')"
        title="图片内容"
        name="2"
      >
        <div class="content flex" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <img-upload
            :imgSrc.sync="imgSrc"
            imgType="12"
            :defaultImg="defaultImgBg"
            :iconColor.sync="iconColor"
            :showDel="false"
            size="medium"
          ></img-upload>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown($event, '3')"
        title="链接地址"
        name="3"
        v-if="(!isBigScreen && !showColsFieldMapping) || (isBigScreen && !noCacheComponentLayout)"
      >
        <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')">
          <linkSet
            :linkAddress.sync="linkAddress"
            :internalLinkName.sync="internalLinkName"
            :subLinkName.sync="subLinkName"
            :linkUrl.sync="linkUrl"
            :accessRulers.sync="accessRulers"
            :openBlankPage.sync="openBlankPage"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item v-if="!noCacheComponentLayout && !(pageType === 'detailPage' && noCacheComponent) && noCacheComponent" @mousedown.native="collapseMouseDown($event, '5')" title="更多" name="5">
        <div>
          <auto-update-timer />
          <!-- <div class="mb16" v-show="options.appId">
            <cx-check-box :value.sync="emptyDataShowLocal">
              <span>数据为空时显示以下图片</span>
              <el-tooltip
                popper-class="width200"
                effect="dark"
                content="勾选后，数据源为空时，图片组件显示你所配置的内容，未勾选，数据源为空时，图片组件显示默认图片样式"
                placement="top"
                :open-delay="1000"
              >
                <span class="tips-btn icon-portal-info2"></span>
              </el-tooltip>
            </cx-check-box>
            <div v-if="emptyDataShowLocal" class="mt12">
              <img-upload
                :imgSrc.sync="emptyImgSrc"
                imgType="12"
                :defaultImg="defaultImgBg"
                :iconColor.sync="iconColor"
                :showDel="false"
                :showSize="false"
                size="medium"
              ></img-upload>
            </div>
          </div> -->
          <emptyDataShow class="mb16" v-show="options.appId && noCacheComponent !== '3'" :options="options"></emptyDataShow>
          <div class="mb16">
            <!-- <div class="getDataBtn mb16" @click="getBaseModuleDataLoop">查看数据响应结果</div> -->
            <cx-check-box  v-if="request_prefix==='bigScreen'"  :value.sync="usePageQuery">开启跨页面传参</cx-check-box>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import detailPageFieldMappingSetting from "publicSetting/detailPageFieldMappingSetting.vue"
import multiImageFieldMappingSetting from "publicSetting/multiImageFieldMappingSetting.vue"
import defaultImgBg from "assets/images/empty_img_bg.png"
import autoUpdateTimer from "components/toolbar-option-components/utilsComponents/autoUpdateTimer/autoUpdateTimer.vue"
import { isExist } from "utils"
import colsFieldMappingSetting from "publicSetting/colsFieldMappingSetting.vue"
import { historyIgnoreWrap } from "utils/revork"
import dataCenterChoose from "publicSetting/dataCenterChoose.vue"
import listPageFieldMappingSetting from "publicSetting/listPageFieldMappingSetting.vue"
import emptyDataShow from "./emptyDataShow.vue"
import dataToolMixin from "materials/dataToolMixin"
import currentFieldMappingSetting from "publicSetting/currentFieldMappingSetting.vue"

export default {
  name: "image-options-data",
  components: { detailPageFieldMappingSetting, multiImageFieldMappingSetting, autoUpdateTimer, colsFieldMappingSetting, dataCenterChoose, listPageFieldMappingSetting, emptyDataShow, currentFieldMappingSetting },
  mixins: [dataToolMixin],
  props: {
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      labelTrue: true,
      labelFalse: false,
      activeNames: ["1", "2", "3", "4"],
      collapseActiveNames: ["1", "2", "3", "4"],
      defaultImgBg: defaultImgBg,
      fetchEnd: false,
      layoutMapping: false
    }
  },
  mounted() {
    if (this.options.layoutUidMap && !this.isBigScreen) {
      this.layoutMapping = true
    }
    if (this.noCacheComponentLayout && !this.isBigScreen) {
      historyIgnoreWrap(() => {
        this.noCacheComponent = false
      })()
    }
    this.$eventBus.$on("update-toolbar-data", this.updateToolbarData)
  },
  beforeDestroy() {
    this.$eventBus.$off("update-toolbar-data", this.updateToolbarData)
  },
  computed: {
    showColsFieldMapping() {
      return this.dataIds?.uid || isExist(this.dataIds?.elementInSwiperId) || this.dataIds?.elementInDataGridId
    },
    isShowChooseData(){
      // 特殊场景允许去本地数据设置数据
      if(!this.notLocal && this.options && this.options.pluginName &&
      this.options.pluginName.indexOf("fetch-showChooseData")!== -1){
        return true
      }
      return  false
    },
    linkAddress: {
      get() {
        return this.options.linkAddress || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkAddress", false)
      }
    },
    isBigScreen() {
      if (this.request_prefix == "bigScreen") {
        return true
      } else {
        return false
      }
    },
    pageType() {
      return this.$store.state[this.request_prefix].type
    },
    imgSrc: {
      get() {
        return this.options.imgSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "imgSrc", false)
      }
    },
    openBlankPage: {
      get() {
        return this.options.openBlankPage
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openBlankPage", false)
      }
    },
    internalLinkName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "internalLinkName", "internalLinkName", "")
      },
      set(val) {
        this.$changeOptionsEV(val, "internalLinkName", false)
      }
    },
    subLinkName: {
      get(val) {
        return this.checkAndSetPrimaryVal(this.options, "subLinkName", "subLinkName", "")
      },
      set(val) {
        this.$changeOptionsEV(val, "subLinkName", false)
      }
    },
    linkUrl: {
      get() {
        return this.options.linkUrl
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "linkUrl", false)
      }
    },
    restDataUrl: {
      get() {
        return this.options && this.options.restDataUrl !== "" ? this.options.restDataUrl : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "restDataUrl", false)
      }
    },
    usePageQuery: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "usePageQuery", "usePageQuery", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "usePageQuery", false)
      }
    },
    filedMapping: {
      get() {
        return this.options.filedMapping
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "filedMapping", false)
      }
    },
    notLocal: {
      get() {
        if(this.noCacheComponentLayout) {
          return !!this.options.filedMapping?.value
        } else {
          return this.noCacheComponent
        }
      },
      set(newVal) {
        if(this.noCacheComponentLayout) {
          if (!this.filedMapping) this.filedMapping = {}
          this.$changeOptionsEV(newVal ? "0" : "", "filedMapping.value", false)
        } else {
          this.noCacheComponent = newVal
        }
        if (this.detailFieldMapping?.hasOwnProperty("isChecked")) {
          this.$changeOptionsEV(newVal === "3", "detailFieldMapping.isChecked", false, null, this.ids)
        }
      }
    },
    detailFieldMapping() {
      return this.options.detailFieldMapping || {}
    },
    noCacheComponent: {
      get() {
        return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "noCacheComponent", false, null)
        // 如果在详情页中文本组件选中外接数据源，需要先初始化文本组件在详情页的相关对象属性detailFieldMapping，同时给文本组件增加在详情页中请求数据源的插件
        // 切换到本都数据的时候，清除之前绑定的appId
        if (!newVal) {
          this.$changeOptionsEV("", "appId", false, false, false, true)
        }
        if (this.pageType === "detailPage" && newVal || (this.pageType === "listPage" && newVal === "3")) {
          this.$changeOptionsEV(
            {
              isChecked: false,
              dataType: "dataValue",
              fieldFlag: ""
            },
            "detailFieldMapping",
            false,
            false,
            false,
            true
          )
        }
      }
    },
    accessRulers: {
      get() {
        return this.options.accessRulers ? this.options.accessRulers : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "accessRulers", false)
      }
    },
    iconColor: {
      get() {
        return this.options.iconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
    emptyDataShowLocal: {
      get() {
        return this.options.hasOwnProperty("emptyDataShowLocal") ? this.options.emptyDataShowLocal : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyDataShowLocal", false, null)
      }
    },
    emptyImgSrc: {
      get() {
        return this.options.emptyImgSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyImgSrc", false)
      }
    },
    hasGetDetailDataPlugin() {
      return this.layoutOptions?.pluginName?.includes("getDetailDataPlugin")
    },
    dataOptions() {
      const options = [{ value: false, title: "本地数据" }]
      if (this.pageType === "detailPage" || this.showColsFieldMapping) {
        options.push({ value: true, title: "数据绑定" })
      } else if((this.isBigScreen && !this.noCacheComponentLayout) || (!this.isBigScreen && !this.showColsFieldMapping)) {
        options.push({ value: true, title: "数据中心" })
      }
      if (this.pageType === "listPage" && !this.noCacheComponentLayout || this.directionTitle) {
        options.push({ value: "3", title: "数据绑定" })
      }
      return options
    },
    checkStatus() {
      return this.getAttrById.call(this, this.$store.state[this.request_prefix], this.dataIds)
    }
  },
  methods: {
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    async getBaseModuleDataLoop() {
      if (!this.checkStatus) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "error",
          message: "请进入数据管理后台添加数据"
        })
        return
      }
      this.updateNormalRect
        .call(this, datas => {
          if (datas.length === 0) {
            if (this.emptyDataShowLocal) {
              this.imgSrc = this.emptyImgSrc
            }
            this.$changeOptionsEV(true, "isEmptyData", false, null, this.ids, true)
          } else {
            this.$changeOptionsEV(false, "isEmptyData", false, null, this.ids, true)
            this.imgSrc = datas[0][Object.keys(datas[0])[0]].value
          }
        })
        .then(restDataUrl => {
          this.restDataUrl = restDataUrl
        })
    },
    goToChooseData() {
      if (this.fetchEnd) return
      this.fetchEnd = true
      const { websiteId, pageId } = this.$store.state.states.getDataPageIds
      let { moduleId, appId } = this.options
      if (moduleId === undefined) moduleId = this.options?.moduleId
      if (appId === undefined) appId = this.options?.appId
      if (!appId) {
        this.$saveModule(this.ids, "31CB73E03E24BBFF", "临时")
            .then(res => {
              this.fetchEnd = false
              if (!!res.appId) {
                // 模板问题，第一次需要手动将数据源切换为本地数据
                this.$API.setLocalData({ appId: res.appId, type: "general" }).then(() => {
                  window.open(`/engine2/data/api-v2/admin/general/${res.appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
                })
              }
            })
            .catch(err => (this.fetchEnd = false))
      }
      this.fetchEnd = false
      if (!!appId) window.open(`/engine2/data/api-v2/admin/general/${appId}?w=${websiteId}&p=${pageId}&hideDataContent=true`)
      // 数据自动渲染
      this.appId = appId
      // window.addEventListener("storage", this.listenData)
    },
    onDataCenterChange() {
      if(!this.showColsFieldMapping || !this.noCacheComponentLayout) {
        this.getBaseModuleDataLoop()
      }
    },
    updateToolbarData() {
      if(!this.showColsFieldMapping || !this.noCacheComponentLayout) {
        this.getBaseModuleDataLoop()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.getDataBtn {
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 6px 0px;
}
.getDataBtn:hover {
  cursor: pointer;
}
.dataSource-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  background: var(--leftMenuBgColor);
  border: 1px solid var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  color: var(--themeColor);
  &:hover {
    cursor: pointer;
  }
}
.dataUrl-item input {
  width: 252px;
  height: 32px;
  background: #35383f;
  color: var(--fourthTextColor);
}
.dataUrl-item .tips {
  color: var(--fourthTextColor);
}
.mt4 {
  margin-top: 4px;
}
.width200 {
  width: 200px;
}
</style>
